"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PetDetailsForm = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uuid = require("uuid");
var _helpers = require("../../helpers");
var _AnimalRadios = require("../../components/Forms/FormElements/Radios/AnimalRadios/AnimalRadios");
var _SectionWrapper = require("../../components/UIElements/SectionWrapper/SectionWrapper");
var _InputText = require("../../components/Forms/FormElements/InputText");
var _BreedAutoComplete = require("../../components/Forms/FormElements/AutoComplete/Breeds/BreedAutoComplete");
var _AnimalBirthdate = require("../../components/Forms/FormElements/SpecialInputs/Birthdates/AnimalBirthdate");
var _AnimalBirthdateDatepicker = require("../../components/Forms/FormElements/SpecialInputs/Birthdates/AnimalBirthdateDatepicker");
var _StyledRadios = require("../../components/Forms/FormElements/Radios/StyledRadios/StyledRadios");
var _Icon = require("../../components/UIElements/Icons/PetSure/Icon");
var _DefaultPetDetailsDisplaySettings = require("./DefaultPetDetailsDisplaySettings");
var _petDetailsPropTypes = require("../../propTypes/petDetailsPropTypes");
var _petDetailsFormDisplaySettingsPropTypes = require("../../propTypes/petDetailsFormDisplaySettingsPropTypes");
require("./petDetailsForm.scss");
var _objectHelpers = require("../../helpers/objectHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const PetDetailsForm = _ref => {
  let {
    formContext,
    petDetailsDisplaySettings,
    routeDispatcher,
    formId = "petDetailsForm_".concat((0, _uuid.v4)().split('-')[0]),
    petNumber = 0,
    petDetails,
    globalDispatcher,
    includeAddAnotherPetButton = false,
    onAddAnotherPet = () => {},
    includeRemovePetButton = false,
    onRemovePet = () => {}
  } = _ref;
  const pet = (0, _react.useMemo)(() => petDetails || _petDetailsPropTypes.emptyPetDetails, [petDetails]);
  const missingDispatcher = () => {
    /* eslint-disable-next-line no-console */
    console.log('No dispatcher provided to PetDetailsForm to handle updates.');
  };
  const dispatcher = globalDispatcher || routeDispatcher || missingDispatcher;
  const {
    heading,
    accordionBehaviour,
    petSpeciesRadios,
    petNameInput,
    petBreedInput,
    petBirthdate,
    petGenderRadios,
    petDesexedRadios
  } = (0, _objectHelpers.OverrideMergeObjects)({
    baseObject: _DefaultPetDetailsDisplaySettings.DefaultPetDetailsDisplaySettings,
    overrideObject: petDetailsDisplaySettings || {}
  });
  const getSectionHeading = () => {
    if (typeof heading === 'function') {
      return heading({
        petName: pet.petName
      });
    }
    return "About ".concat(pet.petName ? pet.petName : 'your pet');
  };
  const handlePetTypeChange = species => {
    dispatcher({
      type: 'setPetSpecies',
      species,
      petNumber
    });
  };
  const handleNameChange = event => {
    const petName = (0, _helpers.Capitalize)(event.target.value);
    dispatcher({
      type: 'setPetName',
      petName,
      petNumber
    });
    event.target.value = petName;
  };
  const handleGenderChange = gender => {
    dispatcher({
      type: 'setPetGender',
      gender,
      petNumber
    });
  };
  const handleBirthdateChange = event => {
    dispatcher({
      type: 'setPetBirthdate',
      petBirthdate: event.target.value,
      petNumber
    });
  };
  const handleBreedSelection = breed => {
    dispatcher({
      type: 'setPetBreed',
      breed,
      petNumber
    });
  };
  const handleDesexedChange = desexed => {
    dispatcher({
      type: 'setPetDesexed',
      desexed,
      petNumber
    });
  };
  return /*#__PURE__*/_react.default.createElement(_SectionWrapper.SectionWrapper, {
    isFixed: !accordionBehaviour,
    customCssClass: "petDetailsForm",
    heading: getSectionHeading(),
    isOpen: true
  }, /*#__PURE__*/_react.default.createElement(_AnimalRadios.AnimalRadios, _extends({
    fieldFormContext: formContext,
    required: true,
    groupName: "".concat(formId, "_petSpeciesRadios_").concat(petNumber),
    onChange: event => handlePetTypeChange(event)
  }, petSpeciesRadios, {
    value: pet.species,
    name: "".concat(formId, "_petSpecies_").concat(petNumber),
    groupLabel: petSpeciesRadios.groupLabel({
      petName: pet.petName
    })
  })), /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
    fieldFormContext: formContext,
    autoComplete: "off",
    defaultValue: pet.petName,
    customChangeHandler: event => handleNameChange(event)
  }, petNameInput, {
    name: "".concat(formId, "_petName_").concat(petNumber),
    label: petNameInput.label({
      gender: pet.gender,
      petName: pet.petName
    })
  })), /*#__PURE__*/_react.default.createElement(_BreedAutoComplete.BreedAutoComplete, _extends({
    fieldFormContext: formContext,
    defaultValue: pet.breed,
    onSelectWithData: event => handleBreedSelection(event)
  }, petBreedInput, {
    name: "".concat(formId, "_petBreed_").concat(petNumber),
    label: petBreedInput.label(pet.petName)
  })), /*#__PURE__*/_react.default.createElement(_AnimalBirthdate.AnimalBirthdate, _extends({
    fieldFormContext: formContext,
    defaultValue: pet.petDOB ? (0, _helpers.DateToShortIsoString)(new Date("".concat(pet.petDOB))) : null,
    customChangeHandler: event => handleBirthdateChange(event)
  }, petBirthdate, {
    name: "".concat(formId, "_petBirthdate_").concat(petNumber),
    label: petBirthdate.label(pet.petName)
  })), /*#__PURE__*/_react.default.createElement(_AnimalBirthdateDatepicker.AnimalBirthdateDatepicker, _extends({
    fieldFormContext: formContext,
    defaultValue: pet.petDOB ? (0, _helpers.DateToShortIsoString)(new Date("".concat(pet.petDOB))) : ''
  }, petBirthdate, {
    name: "".concat(formId, "_petBirthdateDatepicker_").concat(petNumber),
    label: petBirthdate.label(pet.petName)
  }))), /*#__PURE__*/_react.default.createElement(_StyledRadios.StyledRadios, _extends({
    fieldFormContext: formContext,
    groupName: "".concat(formId, "_petGenderRadios_").concat(petNumber),
    required: true,
    onChange: event => handleGenderChange(event),
    value: pet.gender
  }, petGenderRadios, {
    name: "".concat(formId, "_petGender_").concat(petNumber),
    groupLabel: petGenderRadios.groupLabel(pet.petName)
  })), /*#__PURE__*/_react.default.createElement(_StyledRadios.StyledRadios, _extends({
    fieldFormContext: formContext,
    groupName: "".concat(formId, "_petDesexedRadios_").concat(petNumber),
    required: true,
    value: "".concat(pet.desexed),
    onChange: event => handleDesexedChange(event)
  }, petDesexedRadios, {
    name: "".concat(formId, "_petDesexed_").concat(petNumber),
    groupLabel: petDesexedRadios.groupLabel(pet.petName)
  })), /*#__PURE__*/_react.default.createElement("footer", null, includeRemovePetButton && /*#__PURE__*/_react.default.createElement("button", {
    id: "".concat(formId, "_removePetButton"),
    className: "button primary inverse",
    type: "button",
    onClick: () => onRemovePet(petNumber)
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "minus"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, "Remove ", pet.petName || 'pet')), includeAddAnotherPetButton && /*#__PURE__*/_react.default.createElement("button", {
    id: "".concat(formId, "_addPetButton"),
    className: "button primary",
    type: "button",
    onClick: () => onAddAnotherPet()
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "plus"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, "Insure another pet"))));
};
exports.PetDetailsForm = PetDetailsForm;
PetDetailsForm.propTypes = {
  petDetails: _propTypes.default.shape(_petDetailsPropTypes.PetDetailsPropType),
  petDetailsDisplaySettings: _propTypes.default.shape(_petDetailsFormDisplaySettingsPropTypes.PetDetailsFormDisplaySettingsPropTypes),
  petNumber: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  globalDispatcher: _propTypes.default.func,
  includeAddAnotherPetButton: _propTypes.default.bool,
  onAddAnotherPet: _propTypes.default.func,
  includeRemovePetButton: _propTypes.default.bool,
  onRemovePet: _propTypes.default.func,
  accordionBehaviour: _propTypes.default.bool,
  // eslint-disable-next-line react/forbid-prop-types
  formContext: _propTypes.default.any,
  formId: _propTypes.default.string.isRequired,
  routeDispatcher: _propTypes.default.func
};
var _default = exports.default = {
  PetDetailsForm
};